export enum AssignDiagnosticTestStatus {
  FOUND_EXISTING = 'found_existing',
  CREATED = 'created',
}
